import React from "react";
import { useHistory } from "react-router-dom";
import { Typography, Button, Card, CardContent, Container } from "@mhome/ui";
import { CheckCircle } from "lucide-react";

const DesktopAuthDone = () => {
  const history = useHistory();

  const handleContinue = () => {
    history.push("/");
  };

  return (
    <Container maxWidth="sm">
      <div className="flex min-h-screen flex-col items-center justify-center p-6 text-center">
        <Card className="w-full max-w-[500px] rounded-2xl border bg-card shadow-sm">
          <CardContent className="flex flex-col items-center p-8">
            <CheckCircle className="mb-4 h-20 w-20 text-green-500" />

            <Typography
              variant="h4"
              component="h1"
              className="mb-4 text-foreground"
            >
              Sign-in Complete
            </Typography>

            <Typography variant="body1" className="mb-8 text-muted-foreground">
              You can now continue on the desktop client.
            </Typography>

            <Button
              variant="default"
              size="lg"
              onClick={handleContinue}
              className="rounded-full px-8 py-3 text-lg"
            >
              Go to Main Page
            </Button>
          </CardContent>
        </Card>
      </div>
    </Container>
  );
};

export default DesktopAuthDone;
